/**
 * Lightweight pub/sub for «Разобрать ошибку» visibility.
 * No UI / confirmationPopup imports — safe for hooks.ts.
 */

type Listener = () => void;

const listeners = new Set<Listener>();

export function notifyMessarioAiTrainingDraftChanged() {
  listeners.forEach((listener) => {
    try {
      listener();
    } catch(err) {
      console.warn('Messario AI training draft UI listener failed', err);
    }
  });
}

export function subscribeMessarioAiTrainingDraftChanged(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
